
import MENU_AU from './suppliers.au.json'
import MENU_UK from './suppliers.uk.json'

type SuppliersDataType = {
  [key in 'au' | 'uk']: {
    popular_categories: [{
      icon: string
      title: string
      url: string
    }]
    all_categories: [{
      title: string
      items: [{
        title: string
        url: string
        target?: string
      }]
    }]
    locations: [{
      title: string
      url: string
    }]
  }
}

export default {
  'au': MENU_AU,
  'uk': MENU_UK,
} as SuppliersDataType